/**
 * Wrapper for jQuery UI datepicker widget for scheduled updates
 *
 * This wrapper prevents the jQuery datepicker from autocorrecting invalid date inputs
 * into valid ones. It also has the option to validate the inputed date
 *
 * @author David Dong (ddong@yext.com)
 */

goog.module('yext.scheduledupdates.DatePicker');
goog.module.declareLegacyNamespace();

/**
 * Constructor for the datepicker
 *
 * @param {!Object} 	  $ctx          jQuery object for the datepicker
 * @param {!Object?}   $submit       submit button attached to the datepicker
 * @param {!Object?}	  options       jQuery options of the datepicker
 * @param {Function?(Date) -> bool} onValidate 	  validation callback
 *
 * @constructor
 * @suppress {deprecated}
 */
const DatePicker = function($ctx, $submit, options, onValidate) {
  this.$ctx = $ctx;
  this.options = options || {};
  this.onValidate = onValidate;
  this.$submit = $submit;

  this.initDatePicker();
};

/**
 * Initialize datepicker
 * @suppress {deprecated}
 */
DatePicker.prototype.initDatePicker = function() {
  var self = this;
  this.options.beforeShow = function(input, inst) {
    $(inst.dpDiv).addClass('scheduled-updates-datepicker');
  };
  this.options.onClose = function() {
    $(this).blur();

    if (self.$submit.length > 0 && self.onValidate) {
      try {
        self.$submit.prop('disabled', !self.onValidate(self.parseDate()));
      } catch (err) {
        self.$submit.prop('disabled', true);
      }
    }
  };

  this.$datepicker = this.$ctx.datepicker(this.options).attr('autocomplete', 'off');
};

/**
 * parse the date entered into the datepicker object
 *
 * @param {!Object}  $datepicker   jQuery UI datepicker
 *
 * @return {Date} the parsed date
 * @throws Invalid arguments, Missing number, Unknown name, Unexpected literal, invalid date
 * @suppress {deprecated}
 */
DatePicker.prototype.parseDate = function() {
  var format = this.$datepicker.datepicker('option', 'dateFormat');
  var date = this.$datepicker.val();
  return $.datepicker.parseDate(format, date);
};

exports = DatePicker;
